export default "__VITE_ASSET__DupLetY2__"